var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"px-0",class:_vm.$vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''},[_vm._v("Meine Fristen"),_c('v-spacer'),_c('v-btn',{staticClass:"mr-2",attrs:{"text":"","outlined":"","small":"","to":{
          name: 'member-management-personnel-records-details-deadlines',
          params: {
            organizationId: _vm.$route.params.organizationId,
            itemId: _vm.currentUserUid,
          },
        }}},[_vm._v("Details anzeigen")])],1),_c('div',[_c('personnel-record-deadlines-data-list',{attrs:{"hideHeader":"","deadlineEntries":_vm.deadlinesCacheWithStatus.entries,"show-update-button":false,"loading":_vm.helpers.dataIsLoading}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }